import devLogo from '../assets/dev_logo.png';
import dev2Logo from '../assets/dev2_logo.png';
import testLogo from '../assets/test_logo.png';
import prodLogo from '../assets/prod_logo.png';

/**
 * Maps REACT_APP_ENVIRONMENT_STATUS to `src/assets/${status}_logo.png` where that file exists.
 * `prod` and unknown keys resolve to no logo (null).
 */
const ENVIRONMENT_STATUS_LOGOS = {
    dev: devLogo,
    dev2: dev2Logo,
    test: testLogo,
    test2: testLogo,
    prod2: prodLogo,
    prod: prodLogo,
    local: devLogo,
    sandbox: testLogo
};

/** Raster URL (or null) for the current build environment. */
export function getEnvironmentLogoSrc() {
    const env = process.env.REACT_APP_ENVIRONMENT_STATUS;
    return ENVIRONMENT_STATUS_LOGOS[env] ?? null;
}

export { ENVIRONMENT_STATUS_LOGOS };
